import { axiosInstance } from "@/lib/axios";
import { CommentsResponse, CreateCommentPayload, CreateCommentResponse, GetCommentsParams } from "./types";

export async function getComments(params: GetCommentsParams): Promise<CommentsResponse> {
  const p = new URLSearchParams();
  p.set("id", String(params.id));
  p.set("type", params.type);
  // Send 1/0 instead of true/false string if API requires boolean-like validation that fails on "true"/"false" string
  // Or maybe it expects literal "1" or "0"
  if (params.set_child !== undefined) p.set("set_child", params.set_child ? "1" : "0");
  if (params.set_parent !== undefined) p.set("set_parent", params.set_parent ? "1" : "0");

  const { data } = await axiosInstance.get<CommentsResponse>(`/comment?${p.toString()}`);
  return data;
}

export async function createComment(payload: CreateCommentPayload): Promise<CreateCommentResponse> {
  const { data } = await axiosInstance.post<CreateCommentResponse>("/comment", payload);
  return data;
}
